exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".changeLog[data-v-5f1352f0]{margin-bottom:10px}.showMore[data-v-5f1352f0]{text-align:center;margin:20px 0;font-size:18px}.showMoreLink[data-v-5f1352f0]{text-decoration:underline;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f1352f0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ChangeLog.vue
// module id = 153
// module chunks = 0